let PLP
function vuePLP() {
    PLP = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {

            const vehicleSearch = window.vehicleSearch();
            const cartToolsStore = window.cartTools();
            const storeSelector = window.storeSelector()

            const cartAddingId = Vue.ref(null)
            const cartSuccessId = Vue.ref(null)
            const cartEnquiringId = Vue.ref(null)

            const serviceMapping = (serviceList) => {
                return serviceList.flatMap((item) => {
                    if (vehicleSearch?.vehicles?.[0]?.additions?.[item] && typeof vehicleSearch.vehicles[0].additions[item] != 'undefined') {
                        return vehicleSearch.vehicles[0].additions[item];
                    } else {
                        return [];
                    }
                })
            }

            const services = Vue.computed(() => {
                return serviceType.length > 0 && vehicleSearch?.vehicles?.[0]?.additions ? serviceMapping(serviceType) : false
            });

            const productsExist = Vue.computed(() => {
                return services.value.length > 0 ? true : false
            })

            const getCartId = (cartTools) => {
                if (!cartTools) return null
                const cartData = cartTools.cartData?.value || cartTools.cartData || null
                if (cartData?.id) return cartData.id
                try {
                    const raw = localStorage.getItem('cartData')
                    const parsed = raw ? JSON.parse(raw) : null
                    return parsed?.id || null
                } catch (e) { }
                return null
            }

            const getNearestStore = () => {
                try {
                    const storeSelector = window.storeSelector ? window.storeSelector() : null
                    return storeSelector?.nearestStore || null
                } catch (e) { }
                try {
                    const raw = localStorage.getItem('currentNearestStore')
                    return raw ? JSON.parse(raw) : null
                } catch (e) { }
                return null
            }

            const getServiceAvailability = (service) => {
                if (!service.puncture) {
                    return true;
                } else {
                    if (storeSelector?.nearestStore?.node?.punctureRepair?.value != 'true') {
                        return false;
                    } else {
                        return true;
                    }
                }
            }

            const setCartEnquiring = (service) => {
                cartEnquiringId.value = service?.variantGid || null
            }

            const sendEnquiry = (service) => {

                localStorage.setItem('storeEnquiry', JSON.stringify(
                    {
                        title: service.title || ""
                    }
                ))

                setCartEnquiring(service)
                window.location.href = `${shopifyConfig.storeURL}/pages/${shopifyConfig.contactDefault}`;
            };

            const hasNearestStore = () => {
                return !!getNearestStore()
            }

            const getNearestStoreName = () => {
                const store = getNearestStore()
                const node = store?.node || store
                return node?.name || 'selected store'
            }

            const openStoreSelector = () => {
                const button = document.getElementById('my-store-btn')
                if (button) {
                    button.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    button.click()
                }
            }

            const addToCart = async (index) => {
                if (!services?.value[index]?.variantGid) return
                setCartAdding(services.value[index])
                if (services.value[index].variantGid) {
                    try {
                        await addVariantToCart(services.value[index].variantGid, 1, false)
                        setCartSuccess(services.value[index])
                    } catch (e) {
                        setCartIdle()
                    }

                }
            }

            const setCartAdding = (service) => {
                cartAddingId.value = service?.variantGid || null
                cartSuccessId.value = null
            }

            const setCartSuccess = (service) => {
                cartAddingId.value = null
                cartSuccessId.value = service?.variantGid || null
                if (cartSuccessTimer) clearTimeout(cartSuccessTimer)
                cartSuccessTimer = setTimeout(() => {
                    cartSuccessId.value = null
                }, 2500)
            }

            const setCartIdle = () => {
                cartAddingId.value = null
                cartSuccessId.value = null
            }

            const isCartAdding = (service) => cartAddingId.value === service?.variantGid
            const isCartSuccess = (service) => cartSuccessId.value === service?.variantGid
            let cartSuccessTimer = null

            const isCartEnquiring = (service) => cartEnquiringId.value === service?.variantGid

            const addVariantToCart = async (variantId, qty, promo) => {
                if (!cartToolsStore || !variantId || !qty) return
                const cartId = getCartId(cartToolsStore)
                try {
                    if (cartId) {
                        await cartToolsStore.cartAdd(variantId.replaceAll('gid://shopify/ProductVariant/', ''), qty, cartId, promo)
                    } else {
                        await cartToolsStore.newCart(variantId.replaceAll('gid://shopify/ProductVariant/', ''), qty, vehicleSearch.vehicles, storeSelector.location, promo)
                    }
                } catch (e) {
                    await cartToolsStore.newCart(variantId.replaceAll('gid://shopify/ProductVariant/', ''), qty, vehicleSearch.vehicles, storeSelector.location, promo)
                }
                cartToolsStore.openCheckout = false
                cartToolsStore.showCart = true
            }

            return {
                productsExist,
                services,
                hasNearestStore,
                getNearestStoreName,
                openStoreSelector,
                addToCart,
                isCartAdding,
                isCartSuccess,
                isCartEnquiring,
                getServiceAvailability,
                sendEnquiry
            };
        }
    })
    PLP.use(window.VueAppGlobals.pinia);
    PLP.mount('#WAPLP');
}

if (window.Vue && window.Pinia) {
    vuePLP()
} else {
    window.addEventListener('vue-ready', vuePLP);
}
